import React, { useState, useEffect } from 'react';
import { 
  Box, Typography, Card, Table, TableBody, TableCell, TableContainer, 
  TableHead, TableRow, Chip, TableSortLabel
} from '@mui/material';
import api from '../../utils/axios';
import { toast } from 'react-toastify';
import { getComparator, stableSort } from '../../utils/sortUtils';

const ManageChurches = () => {
  const [churches, setChurches] = useState([]);
  const [loading, setLoading] = useState(true);

  // Sorting State
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('name');

  useEffect(() => {
    fetchChurches();
  }, []);

  const fetchChurches = async () => {
    try {
      const res = await api.get('/superadmin/churches');
      if (res.data.success) {
        setChurches(res.data.data);
      }
    } catch (err) {
      toast.error('Failed to load churches');
    } finally {
      setLoading(false);
    }
  };

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const sortedChurches = stableSort(churches, getComparator(order, orderBy));

  return (
    <Box>
      <Typography variant="h4" gutterBottom>Manage Churches</Typography>
      
      <Card sx={{ mt: 3, overflow: 'hidden' }}>
        <TableContainer sx={{ maxHeight: '70vh' }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>
                  <TableSortLabel
                    active={orderBy === 'name'}
                    direction={orderBy === 'name' ? order : 'asc'}
                    onClick={() => handleRequestSort('name')}
                  >
                    Church Name
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={orderBy === 'address.city'}
                    direction={orderBy === 'address.city' ? order : 'asc'}
                    onClick={() => handleRequestSort('address.city')}
                  >
                    Address / Location
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={orderBy === 'confirmationCode'}
                    direction={orderBy === 'confirmationCode' ? order : 'asc'}
                    onClick={() => handleRequestSort('confirmationCode')}
                  >
                    Confirmation Code
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={orderBy === 'createdAt'}
                    direction={orderBy === 'createdAt' ? order : 'asc'}
                    onClick={() => handleRequestSort('createdAt')}
                  >
                    Created At
                  </TableSortLabel>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sortedChurches.map((church) => (
                <TableRow key={church._id} hover>
                  <TableCell sx={{ fontWeight: 600 }}>{church.name}</TableCell>
                  <TableCell>
                    {church.address?.city ? `${church.address.city}, ${church.address.state || ''}` : 'No address'}
                  </TableCell>
                  <TableCell>
                    <Chip 
                      label={church.confirmationCode || 'No Code'} 
                      color="primary" 
                      variant="outlined" 
                      size="small" 
                    />
                  </TableCell>
                  <TableCell>
                    {new Date(church.createdAt).toLocaleDateString()}
                  </TableCell>
                </TableRow>
              ))}
              {churches.length === 0 && !loading && (
                <TableRow><TableCell colSpan={4} align="center">No churches found</TableCell></TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
    </Box>
  );
};

export default ManageChurches;
